module.exports = __webpack_public_path__ + "static/media/P.16a8ef9f.svg";